import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[igClickStopPropagation]",
})
export class ClickStopPropagationDirective {
  @HostListener("click", ["$event"])
  public onClick(event: any): void {
    event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/directives/click.stop.propagation/click.stop.propagation.directive.ts